import { graphql } from '@apollo/client/react/hoc';
import component from './component';
import productsQuery from './productsQuery.graphql';

export default graphql(productsQuery, {
  props: ({ data: { popular, newProducts } }) => ({ popular, newProducts })
})(component);
